export default __webpack_public_path__ + "static/media/castledown-heavy.d6e04b3d.ttf";